import React, { useCallback, useState, useRef, useMemo } from "react";
import {
  DropZone,
  InlineStack,
  FormLayout,
  TextField,
  Thumbnail,
  Checkbox,
  Toast,
  Icon,
  Popover,
  ActionList,
  Button,
  Text,
  Loading,
  ChoiceList,
  Select,
  InlineError,
  ButtonGroup,
} from "@shopify/polaris";
import { useParams } from "react-router-dom";
import axios from "../Assets/Lib/axios";
import {
  NoteMinor,
  LanguageIcon,
  MenuVerticalIcon,
} from "@shopify/polaris-icons";
import { Editor } from "@tinymce/tinymce-react";
import JoditEditor from "jodit-react";

const JoditEditorComponent = (props) => {
  //console.log("aaaaaaaaaaaaa");
  const fileInputRef = useRef(null);

  const options = [
    "bold",
    "italic",
    "|",
    "ul",
    "ol",
    "hr",
    "fullsize",
    "table",
    "link",
  ];
  const configWithToolbar = useMemo(
    () => ({
      readonly: false,
      placeholder: "",
      defaultActionOnPaste: "insert_as_html",
      defaultLineHeight: 1.5,
      enter: "div",
      // options that we defined in above step.
      buttons: [
        "bold",
        "italic",
        "ul",
        "ol",
        "hr",
        "fullsize",
        "table",
        // "link",
        "align",
        "image",
      ],
      statusbar: false,
      sizeLG: 900,
      sizeMD: 700,
      sizeSM: 400,
      toolbarAdaptive: false,
      toolbar: true,
    }),
    []
  );
  const configWithoutToolbar = useMemo(
    () => ({
      readonly: false,
      placeholder: "",
      toolbar: false,
    }),
    []
  );

  const editorRef = useRef(null);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleImageUpload(file);
    }
  };

  const handleImageUpload = async (file) => {
    console.log("aaaaaa");
    const formData = new FormData();
    formData.append("image", file);
    formData.append("entity_type", "rich_text");

    try {
      const response = await axios.post("s3/save-file", formData);
      const imageUrl = response.data.data.file_url; // URL of the uploaded file
      console.log("imageUrl=", imageUrl);
      insertImageAtCursor(imageUrl);
      // const editorInstance = editor.current;
      props.handleChangeValue(props.value + `<img src=${imageUrl}></img>`);
      // setInstructionValue(instructionValue + `<img src=${imageUrl}></img>`);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };
  // const insertImageAtCursor = (imageUrl) => {
  //   const editor = editorRef.current;
  //   if (!editor) return;
  //   const selection = window.getSelection();
  //   if (!selection) return;
  //   const range = selection.getRangeAt(0);
  //   const newImage = document.createElement("img");
  //   newImage.setAttribute("src", imageUrl);
  //   newImage.setAttribute("alt", "Image");
  //   range.insertNode(newImage);
  //   props.handleChangeValue(editor.innerHTML);
  //   // setInstructionValue(editor.innerHTML);
  // };

  const insertImageAtCursor = (imageUrl) => {
    const editorInstance = editorRef.current?.editor;
    if (!editorInstance) return;

    editorInstance.selection.insertHTML(
      `<img src="${imageUrl}" alt="Image" />`
    );
    const updatedValue = editorInstance.value;
    props.handleChangeValue(updatedValue);
  };
  return (
    <div>
      <div
        id="ed1"
        style={{
          display: props.boolRichTextTools ? "block" : "none",
          maxWidth: "400px",
          wordWrap: "break-word",
          whiteSpace: "normal",
        }}
      >
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
          accept="image/*"
        />
        <JoditEditor
          ref={editorRef}
          value={props.value}
          config={useMemo(
            () => ({
              readonly: false,
              placeholder: "",
              defaultActionOnPaste: "insert_as_html",
              defaultLineHeight: 1.5,
              enter: "div",
              // options that we defined in above step.
              buttons: [
                "bold",
                "italic",
                "underline",
                "paragraph",
                "ul",
                "ol",
                "hr",
                "fullsize",
                "table",
                // "link",
                "align",
                "source",
              ],
              controls: {
                paragraph: {
                  list: {
                    p: "Paragraph",
                    h1: "Heading 1",
                    h2: "Heading 2",
                    h3: "Heading 3",
                    h4: "Heading 4",
                    h5: "Heading 5",
                    h6: "Heading 6",
                  },
                  tags: ["p", "h1", "h2", "h3", "h4", "h5", "h6"],
                },
              },
              statusbar: false,
              sizeLG: 900,
              sizeMD: 700,
              sizeSM: 400,
              toolbarAdaptive: false,
              toolbar: true,
              extraButtons: [
                {
                  name: "customLink",
                  iconURL:
                    "https://img.icons8.com/material-outlined/24/000000/link.png",
                  tooltip: "Insert Custom Link",
                  exec: (editor) => {
                    const url = prompt("Enter link URL");
                    if (url) {
                      const sel = editor.selection;
                      if (sel.range) {
                        editor.execCommand("createLink", false, url);
                      }
                    }
                  },
                },
                {
                  name: "customImage",
                  iconURL:
                    "https://img.icons8.com/material-outlined/24/000000/image.png", // Custom icon URL
                  exec: (editor) => {
                    fileInputRef.current.click();
                  },
                  tooltip: "Insert Image",
                },
              ],
              uploader: {
                insertImageAsBase64URI: false, // Do not insert images as base64
              },
            }),
            []
          )}
          onChange={props.handleChangeValue}
        />
        {/* <Editor
          apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
          value={props.value}
          init={{
            statusbar: false,
            branding: false,
            height: props.height,
            menubar: false,
            toolbar_mode: "sliding",
            plugins: [
              "advlist autolink lists link image charmap print preview anchor",
              "searchreplace visualblocks code fullscreen",
              "insertdatetime media table paste code help wordcount fullscreen link",
              "directionality image",
            ],
            toolbar:
              "ltr rtl|image|undo redo | formatselect | bold italic backcolor | \
    alignleft aligncenter alignright alignjustify | \
    bullist numlist outdent indent | removeformat |code|fullscreen | table |link|",
            file_browser_callback_types: "image",
            file_picker_callback: function (callback, value, meta) {
              if (meta.filetype == "image") {
                var input = document.getElementById("my-file");
                input.click();
                input.onchange = function () {
                  var file = input.files[0];
                  console.log(file);
                  var reader = new FileReader();
                  reader.onload = function (e) {
                    console.log("name", e.target.result);
                    const form_data = new FormData();
                    form_data.append("image", file);
                    form_data.append("entity_type", "rich_text");
                    return axios
                      .post("s3/save-file", form_data)
                      .then((res) => {
                        console.log("tessst=", res);
                        console.log("tessst2===", res.data.data.file_url);
                        let url = res.data.data.file_url;
                        callback(url, {
                          alt: file.name,
                        });
                      })
                      .catch((err) => console.log(""));
                  };
                  reader.readAsDataURL(file);
                };
              }
            },
          }}
          onEditorChange={props.handleChangeValue}
          disabled={props.disabled}
        /> */}
      </div>
      <div
        id="ed2"
        style={{
          display: props.boolRichTextTools ? "none" : "block",
          maxWidth: "400px",
          wordWrap: "break-word",
          whiteSpace: "normal",
        }}
      >
        <JoditEditor
          ref={editorRef}
          value={props.value}
          config={configWithoutToolbar}
          onChange={props.handleChangeValue}
        />
        {/* <Editor
          apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
          value={props.value}
          init={{
            height: props.height,
            statusbar: false,
            branding: false,
            menubar: false,
            plugins: [
              "advlist autolink lists link image charmap print preview anchor",
              "searchreplace visualblocks code fullscreen",
              "insertdatetime media table paste code help wordcount fullscreen",
            ],
            toolbar: false,
          }}
          onEditorChange={props.handleChangeValue}
          disabled={props.disabled}
        /> */}
      </div>
    </div>
  );
};

export default JoditEditorComponent;
